/**
 * Banner shown on scan/agent trigger pages when an endpoint project's domain
 * is not yet verified. Scans and agents are blocked until verification; this
 * points the user to project settings to complete it.
 */
import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function DomainGateBanner({
  orgId, portfolioId, projectId, domain,
}: { orgId: string; portfolioId: string; projectId: string; domain?: string }) {
  const settingsPath = `/orgs/${orgId}/portfolios/${portfolioId}/projects/${projectId}/settings`;
  return (
    <div className="rounded-xl border border-amber-500/30 bg-amber-500/5 p-4 flex items-start gap-3">
      <ShieldAlert className="h-5 w-5 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-foreground">Verify domain ownership to unlock scans</p>
        <p className="text-sm text-muted-foreground mt-0.5">
          Scans and agents are disabled until you prove you control
          {domain ? <> <span className="font-mono text-foreground">{domain}</span></> : ' this domain'}.
          Verify via a DNS TXT record or an HTML meta tag in project settings.
        </p>
      </div>
      <Link to={settingsPath} className="shrink-0">
        <Button size="sm" variant="outline">Verify domain</Button>
      </Link>
    </div>
  );
}
